export default __webpack_public_path__ + "static/Bronzed-f9bfec452ce16635f2c112424a610781.png";